import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  FormGroup,
  Label,
} from "reactstrap";
import { P, H6, Btn } from "../../../AbstractElements";
import { WithdrawTitle, RequestWithdraw } from "../../../utils/Constant";
import { IoWalletOutline } from "react-icons/io5";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import HistoryTable from "../../../CommonElements/SearchTable/SearchTable";
import { useSweetAlert } from "../../../Context/SweetAlertContext";
import Loader from "../../../CommonElements/Loader/Loader";
import { decryptData } from "../../../utils/helper/Crypto";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useWithdrawService } from "../../../Service/Withdraw/Withdraw";
import { Eye, EyeOff } from "react-feather";
import {
  WithdrawFormPropsType,
  WithdrawForminitialValues,
} from "../../../Type/Forms/FormsType";
import Marquee from "react-fast-marquee";

const WalletTransferFxstPayPageContainer = () => {
  const { getWalletBalance, withdraw, loading } = useWithdrawService();
  const { showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert();

  const [walletBalance, setWalletBalance] = useState<number>(0);
  const [tokenRate, setTokenRate] = useState<number>(0);
  const [token, setToken] = useState("");
  const [MinAmount, setMinAmount] = useState(0);
  const [MaxAmount, setMaxAmount] = useState(0);
  const [isWithdrawAllowed, setIsWithdrawAllowed] = useState(true);
  const [showFeeMsg, setShowFeeMsg] = useState(false);
  const [feeMsg, setFeeMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);


  const ClientID = decryptData(localStorage.getItem("clientId") || "");

  // Validation Schema
  const WithdrawSchema = Yup.object().shape({
    WalletType: Yup.string().required("Select Wallet Type"),
    WithdrawAmount: Yup.number()
      .min(MinAmount, `Minimum withdraw amount is ₹${MinAmount}`)
      .max(MaxAmount, `Maximum withdraw amount is ₹${MaxAmount}`)
      .required("Enter Withdraw Amount"),
      Password: Yup.string().required("Enter Your Login Password"),
  });

  useEffect(() => {
    handleWalletChange("CommissionWallet");
  }, []);

  const handleWalletChange = async (
    walletType: string,
    setFieldValue?: any
  ) => {
    const paramWallet = {
      ClientId: ClientID,
      WalletType: walletType,
      ActionMode: "GetWalletAmount",
    };
    const objWallet = {
      procName: "WithdrawFund",
      Para: JSON.stringify(paramWallet),
    };
    const walletRes = await getWalletBalance(objWallet);
    const apiData = walletRes[0];

    setWalletBalance(apiData.WalletAmount);
    setToken(apiData.Token);
    setTokenRate(apiData.TokenRate);

    const matches = apiData.ReleaseAmount.match(
      /Minimum<\/b>:(\d+).*Maximum<\/b>:(\d+)/
    );
    if (matches) {
      setMinAmount(Number(matches[1]));
      setMaxAmount(Number(matches[2]));
    }

    if (setFieldValue) {
      setFieldValue("WalletType", walletType);
      setFieldValue("WithdrawAmount", apiData.WalletAmount);
    }

    // KYC check
    const paramKYC = {
      ClientId: ClientID,
      WalletType: walletType,
      ActionMode: "GetKYCStatus",
    };
    const objKYC = { procName: "WithdrawFund", Para: JSON.stringify(paramKYC) };
    const kycRes = await getWalletBalance(objKYC);
    if (kycRes[0]?.IsDisable === "Y") {
      setIsWithdrawAllowed(false);
      showAlert(kycRes[0]?.Msg);
    } else {
      setIsWithdrawAllowed(true);
    }
  };

  const calculateFinalAmount = (amount: number) => amount - amount * 0.15;

  const handleWithdrawAmountBlur = (amount: number) => {
    if (amount > 0) {
      setShowFeeMsg(true);
      setFeeMsg(`Final Amount after 15% fee: ₹${calculateFinalAmount(amount)}`);
    } else {
      setShowFeeMsg(false);
    }
  };

  const handleWithdrawal = async (values: WithdrawFormPropsType) => {
    if (!isWithdrawAllowed) return;

    const confirmed = await ShowConfirmAlert(
      "Withdraw",
      "Are you sure want to withdraw?"
    );
    if (!confirmed) return;

    const payload = {
      procName: "WithdrawFund",
      Para: JSON.stringify({
        ClientId: ClientID,
        WalletType: values.WalletType,
        WithdrawAmount: values.WithdrawAmount,
        Password: values.Password,
        ActionMode: "Withdraw",
      }),
    };

    const res = await withdraw(payload);
    if (res[0]?.StatusCode === "1") {
      ShowSuccessAlert(res[0].Msg);
      handleWalletChange(values.WalletType);
    } else {
      showAlert(res[0]?.Msg || "Error during withdrawal");
    }
  };

  return (
    <>
      <Breadcrumbs
        mainTitle={RequestWithdraw}
        parent={WithdrawTitle}
        ChildName={RequestWithdraw}
      />
          {/* 👉 Marquee Message in Hindi + English */}
<Marquee
  gradient={false}
  speed={50}
  pauseOnHover
  style={{
    backgroundColor: "#00BCD4",
    color: "white",
    fontWeight: "bold",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "15px",
  }}
>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;⚠ You can send withdrawal request from Monday to Friday between 10 AM to 5 PM. &nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  ⚠ निकासी का अनुरोध आप सोमवार से शुक्रवार के बीच सुबह 10 बजे से शाम 5 बजे तक भेज सकते हैं।
</Marquee>
      <Container fluid>
        {loading && <Loader />}
        <Row>
          <Col xl="3">
            <Card className="bg-primary">
              <CardBody>
                <Row className="align-items-center">
                  <Col xl="3">
                    <IoWalletOutline size={50} color="#fff" />
                  </Col>
                  <Col xl="9">
                    <H6 className="text-light">Wallet Balance</H6>
                    <hr />
                    <div className="f-25 text-light fw-600">
                      ₹{walletBalance}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl="9">
            <Card>
              <CardBody>
                <Formik
                  initialValues={WithdrawForminitialValues}
                  validationSchema={WithdrawSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    handleWithdrawal(values);
                    setSubmitting(false);
                  }}
                >
                  {({ isSubmitting, setFieldValue, values }) => (
                    <Form>
                      <Row>
                        <Col md="3">
                          <FormGroup>
                            <Label>My Wallet</Label>
                            <Field
                              as="select"
                              name="WalletType"
                              className="btn-square form-select"
                              value={values.WalletType}
                              onChange={(
                                e: React.ChangeEvent<HTMLSelectElement>
                              ) =>
                                handleWalletChange(
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                            >
                              <option value="">Select</option>
                              <option value="CommissionWallet">
                                My Wallet
                              </option>
                            </Field>
                            <ErrorMessage
                              name="WalletType"
                              component="div"
                              className="text-danger"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <FormGroup>
                            <Label>Withdraw Amount</Label>
                            <Field
                              type="text"
                              name="WithdrawAmount"
                              placeholder="Enter Withdraw Amount"
                              className="form-control"
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                const amount = Number(e.target.value);
                                setFieldValue("WithdrawAmount", amount);
                                setFieldValue(
                                  "FinalAmount",
                                  amount
                                ); // 👈 Final Amount set here
                              }}
                              onBlur={(e: React.FocusEvent<HTMLInputElement>) =>
                                handleWithdrawAmountBlur(Number(e.target.value))
                              }
                            />
                          <P style={{fontSize: "11px", marginTop: "2px"}}><b>Minimum</b>:{`₹${MinAmount}`} <b>Minimum</b>:{`₹${MaxAmount}`}</P>
                            <ErrorMessage
                              name="WithdrawAmount"
                              component="div"
                              className="text-danger"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <Label>Final Amount</Label>
                            <Field
                              type="number"
                              name="FinalAmount"
                              placeholder="Enter Final Amount"
                              className="form-control"
                              value={values.FinalAmount || ""} // 👈 show calculated value
                              readOnly
                            />
                            <P style={{fontSize: "11px", marginTop: "2px"}}><b>Processing Fees</b>: ₹ 0 </P>
                            <ErrorMessage
                              name="WithdrawAmount"
                              component="div"
                              className="text-danger"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
  <FormGroup>
    <Label>Login Password</Label>
    <div className="input-group">
      <Field
        type={showPassword ? "text" : "password"}   // 👈 toggle between text/password
        name="Password"
        placeholder="Enter Your Password"
        className="form-control"
      />
      <button
        type="button"
        className="btn"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
    <ErrorMessage
      name="Password"
      component="div"
      className="text-danger"
    />
  </FormGroup>
</Col>
                        <Col md="2" className="d-flex align-items-center">
                          <Btn
                            color="primary"
                            disabled={isSubmitting || !isWithdrawAllowed}
                          >
                            Submit
                          </Btn>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Col xl="12 mt-4" hidden>
          <HistoryTable />
        </Col>
      </Container>
    </>
  );
};

export default WalletTransferFxstPayPageContainer;
